
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import HeaderGroup from '../HeaderGroup/index.vue'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    HeaderGroup
  }
})
export default class IntroPanel extends Vue {
  @Prop({ required: true }) readonly dataSource!: {
    name: string
    description: string
    cover: string
    memberIds: string[]
  }

  get memberIds() {
    return this.dataSource.memberIds ?? []
  }

  get bgImg() {
    return this.dataSource.cover || this.$images.topic_intro_bg_img
  }

  created(): void {
    this.toJS
  }

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
